<template>
  <div>
  </div>
</template>

<script>
const vermontScript = ` (function (e, t, o, n, p, r, i) {
        e.visitorGlobalObjectAlias = n;
        e[e.visitorGlobalObjectAlias] =
          e[e.visitorGlobalObjectAlias] ||
          function () {
            (e[e.visitorGlobalObjectAlias].q =
              e[e.visitorGlobalObjectAlias].q || []).push(arguments);
          };
        e[e.visitorGlobalObjectAlias].l = new Date().getTime();
        r = t.createElement("script");
        r.src = o;
        r.async = true;
        i = t.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(r, i);
      })(
        window,
        document,
        "https://diffuser-cdn.app-us1.com/diffuser/diffuser.js",
        "vgo"
      );
      vgo("setAccount", "610830346");
      vgo("setTrackByDefault", true);

      vgo("process");`

const northDakotaScript = `  (function (e, t, o, n, p, r, i) {
        e.visitorGlobalObjectAlias = n;
        e[e.visitorGlobalObjectAlias] =
          e[e.visitorGlobalObjectAlias] ||
          function () {
            (e[e.visitorGlobalObjectAlias].q =
              e[e.visitorGlobalObjectAlias].q || []).push(arguments);
          };
        e[e.visitorGlobalObjectAlias].l = new Date().getTime();
        r = t.createElement("script");
        r.src = o;
        r.async = true;
        i = t.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(r, i);
      })(
        window,
        document,
        "https://diffuser-cdn.app-us1.com/diffuser/diffuser.js",
        "vgo"
      );
      vgo("setAccount", "650266755");
      vgo("setTrackByDefault", true);

      vgo("process");`
export default {
  name: 'SmartConductorPixelTracker',
  props: {
    careNetwork: {
      type: String,
      required: true
    }
  },
  created () {
    const str = this.careNetwork.toLowerCase()
    if (str.includes('vermont')) {
      this.appendScript(vermontScript)
    } else if (str.includes('north dakota') || str.includes('nextblue')) {
      this.appendScript(northDakotaScript)
    }
    return null
  },
  methods: {
    appendScript (innerHtml) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.innerHTML = innerHtml
      document.head.appendChild(script)
    }
  }
}
</script>
